import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import AdminForm from '../Form';
import { createAdmin } from '@resources/Admin/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createAdmin, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createAdmin(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.admin.create',
						defaultMessage:
							'A new Admin has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.admin',
					defaultMessage: 'Create Admin',
				})}
			</Title>
			<Section className="mb-5">
				<AdminForm onSubmit={handleSubmit} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createAdmin,
})(Create);
